/**
 * idbConnectPolicy — shared timing constant for the "IDB-before-WS" init
 * pattern used by crdtServiceWS and localFirstSyncService.
 *
 * Both services load IndexedDB before opening the WebSocket connection (to
 * avoid a race where an empty remote doc overwrites locally-cached state),
 * then arm an absolute failsafe timer that forces `connect()` even if IDB
 * sync never fires (blocked storage quota, private-mode restrictions,
 * IndexedDB unavailable, etc.) — the room must never be left permanently
 * stranded with `shouldConnect=false`.
 *
 * The two services independently picked different ceilings (12s vs 8s) for
 * the same failsafe. There's no room-specific reason for that difference —
 * it's drift, not intentional tuning — so both now share one constant.
 */
export const IDB_CONNECT_FAILSAFE_MS = 12_000;
